module.exports = __webpack_public_path__ + "img/img_yijian.684d4cf0.jpg";